import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApplicationCard from "../../components/parent/ApplicationCard";
import Header from "../../components/admin/Header";
import { FaUserGraduate, FaBook, FaCheckCircle, FaClock } from "react-icons/fa"; // Import icons
import API_ENDPOINTS from "../../utils/apiEndpoints";

function AdminDashboard() {
  const [stats, setStats] = useState({
    pendingPayments: { count: 0, "view-details": "" },
    totalRejected: { count: 0, "view-details": "" },
    totalApproved: { count: 0, "view-details": "" },
    totalPending: { count: 0, "view-details": "" },
  });

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("");
  const [tabs, setTabs] = useState([]);
  const [tabData, setTabData] = useState({});
  // const [stats, setStats] = useState({
  //   totalAdmission: 0,
  //   course: 0,
  //   totalApproved: 0,
  //   totalPending: 0,
  // });

  const handleLogout = async () => {
    const token = localStorage.getItem("adminToken");

    try {
      const res = await fetch(API_ENDPOINTS.ADMIN_LOGOUT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      // console.log(data, "admin logout response");

      if (res.ok && data.message === "Logged out") {
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminRole");
        alert("Logged out successfully");
        navigate("/admin/login");
      } else {
        alert("Admin logout failed. Please try again.");
      }
    } catch (error) {
      console.error("Admin logout error:", error);
      alert("An error occurred during admin logout.");
    }
  };


  const adminRole = localStorage.getItem("adminRole");

  const buttons = [
    { text: "Home", route: "/admin/login", color: "bg-blue-500 text-white" },
    {
      text: "Applications",
      route: "/admin/allApplications",
      color: "bg-blue-500 text-white",
    },
    {
      text: "New Admission Entry",
      route: "/admin/manual-admission",
      color: "bg-green-600 text-white font-bold shadow-md",
    },
    ...(adminRole === "super_admin"
      ? [
        {
          text: "Add Users",
          route: "/admin/add-user",
          color: "bg-blue-500 text-white",
        },
      ]
      : []),
    {
      text: "Update Profile",
      route: "/admin/update-profile",
      color: "bg-blue-500 text-white",
    },
    {
      text: "Change Password",
      color: "bg-blue-500 text-white",
      dropdown: [
        { text: "Change Admin Password", route: "/admin/change-password" },
        { text: "Change Parent Password", route: "/admin/change-parent-password" },
      ]
    },
    {
      text: "Logout",
      onClick: handleLogout,
      color: "bg-red-500 text-white",
    },
  ];


  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        // const token = "68|ETVjLkadVCzslIHh3GRviHfIEcw3WCRqDQRMjlfp01e32228";
        const token = localStorage.getItem("adminToken");
        const statsResponse = await fetch(API_ENDPOINTS.ADMIN_DASHBOARD, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!statsResponse.ok) {
          throw new Error(`Error: ${statsResponse.status} ${statsResponse.statusText}`);
        }

        const statsData = await statsResponse.json();



        setStats({
          pendingPayments: {
            count: statsData.data?.pending_payments?.count || 0,
            "view-details": statsData.data?.pending_payments?.["view-details"] || "",
          },
          totalRejected: {
            count: statsData.data?.Rejected?.count || 0,
            "view-details": statsData.data?.Rejected?.["view-details"] || "",
          },
          totalApproved: {
            count: statsData.data?.Approved?.count || 0,
            "view-details": statsData.data?.Approved?.["view-details"] || "",
          },
          totalPending: {
            count: statsData.data?.Pending?.count || 0,
            "view-details": statsData.data?.Pending?.["view-details"] || "",
          },
        });


      } catch (error) {
        console.error("Failed to fetch data:", error.message);
      }
    };

    fetchDashboardData();
  }, []);


  const handlePayNow = (identifier) => {
    // console.log("Payment initiated for:", identifier);
    // Implement your payment logic here
  };
  const handleCardClick = (type, detailsUrl) => {
    if (detailsUrl) {
      // console.log("Navigating to:", `/details/${type}`, "with URL:", detailsUrl);
      navigate(`/admin/details/${type}`, { state: { detailsUrl } });
    }
  };
  return (
    <>
      <Header logo="../ssvk-logo.png" buttons={buttons} />

      <div className="w-full max-w-full sm:px-20 mx-auto p-6">
        {/* Stats Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {/* Total Rejected Card */}
          <div
            className="bg-white p-4 rounded-lg shadow-md text-center cursor-pointer"
            onClick={() => handleCardClick("rejected", stats.totalRejected["view-details"])}
          >
            <div className="flex justify-center">
              <FaUserGraduate className="text-4xl text-blue-600" />
            </div>
            <h3 className="text-sm font-semibold text-gray-600 mt-2">Total Rejected</h3>
            <p className="text-2xl font-bold text-blue-600">{stats.totalRejected?.count || 0}</p>
          </div>

          {/* Pending Payments Card */}
          <div
            className="bg-white p-4 rounded-lg shadow-md text-center cursor-pointer"
            onClick={() => handleCardClick("pending_payments", stats.pendingPayments["view-details"])}
          >
            <div className="flex justify-center">
              <FaBook className="text-4xl text-green-600" />
            </div>
            <h3 className="text-sm font-semibold text-gray-600 mt-2">Pending Payments</h3>
            <p className="text-2xl font-bold text-green-600">{stats.pendingPayments?.count || 0}</p>
          </div>

          {/* Total Approved Card */}
          <div
            className="bg-white p-4 rounded-lg shadow-md text-center cursor-pointer"
            onClick={() => handleCardClick("approved", stats.totalApproved["view-details"])}
          >
            <div className="flex justify-center">
              <FaCheckCircle className="text-4xl text-purple-600" />
            </div>
            <h3 className="text-sm font-semibold text-gray-600 mt-2">Total Approved</h3>
            <p className="text-2xl font-bold text-purple-600">{stats.totalApproved?.count || 0}</p>
          </div>

          {/* Total Pending Card */}
          <div
            className="bg-white p-4 rounded-lg shadow-md text-center cursor-pointer"
            onClick={() => handleCardClick("pending", stats.totalPending["view-details"])}
          >
            <div className="flex justify-center">
              <FaClock className="text-4xl text-red-600" />
            </div>
            <h3 className="text-sm font-semibold text-gray-600 mt-2">Total Pending</h3>
            <p className="text-2xl font-bold text-red-600">{stats.totalPending?.count || 0}</p>
          </div>
        </div>

        {/* Tab Buttons */}
        <div className="flex flex-wrap border-b border-blue-300">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`flex-1 py-3 text-center font-medium text-blue-700 p-3 focus:outline-none ${activeTab === tab ? "bg-blue-200 font-bold" : ""
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.replace(/_/g, " ")}
            </button>
          ))}
        </div>

        {/* Cards Display */}
        <div className="mt-4 space-y-4 max-h-[500px] overflow-y-auto">
          {tabData[activeTab] && tabData[activeTab].length > 0 ? (
            tabData[activeTab].map((item, index) => (
              <ApplicationCard
                key={index}
                item={item}
                isPendingPayment={activeTab === "pending_payments"}
                onPayNow={handlePayNow}
              />
            ))
          ) : (
            <p className="text-center text-gray-500">
              {/* No data available for this tab. */}
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default AdminDashboard;